<template>
    <div class="user">
      <!--搜索表单-->
      <div class="common-seach-wrap">
        <el-form size="small" :inline="true" :model="formInline" class="demo-form-inline">
          <el-form-item label="搜索">
            <el-input size="small" v-model="formInline.search" placeholder="请输入名称/公司名称/用户名称"></el-input>
        </el-form-item>
          <el-form-item label="账号">
            <el-input size="small" v-model="formInline.account" placeholder="请输入账号">
            </el-input></el-form-item>

            <el-form-item label="类型">
            <el-select v-model="formInline.code">
                <el-option label="全部" value=""></el-option>
                <el-option :label="item.name" v-for="(item,index) in codes" :key="index" :value="item.value"></el-option>
                
            </el-select>
        </el-form-item>    

        <el-form-item label="状态">
            <el-select v-model="formInline.status">
                <el-option label="全部" :value="-1"></el-option>
                <el-option label="正常" :value="0"></el-option>
                <el-option label="冻结" :value="1"></el-option>
            </el-select>
        </el-form-item>

          <el-form-item>
            <el-button type="primary" icon="el-icon-search" @click="onSubmit" v-auth="'/plus/password/query'">查询</el-button>
            <el-button type="primary" icon="el-icon-submit" @click="add" v-auth="'/plus/password/add'">添加</el-button>
          </el-form-item>
        </el-form>
      </div>
      <!--内容-->
      <div class="product-content">
        <div class="table-wrap">
          <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading" >
           
            <el-table-column prop="password_id" label="ID"  ></el-table-column>
            <el-table-column prop="user_nickName" label="用户"  ></el-table-column>
            <el-table-column prop="company_name" label="公司名称"  ></el-table-column>
            <el-table-column prop="user_asset_name" label="资产名称"  ></el-table-column>
            <el-table-column prop="name" label="名称"  ></el-table-column>
            <el-table-column prop="code" label="类型"  ></el-table-column>
            <el-table-column prop="owner" label="拥有者"  ></el-table-column>
            <el-table-column prop="email" label="邮箱"  ></el-table-column>
            <el-table-column prop="account" label="账号"  ></el-table-column>
            <el-table-column prop="password" label="密码"  ></el-table-column>
            <el-table-column prop="mobile_one" label="主手机号"  ></el-table-column>
            <el-table-column prop="url" label="网址"  ></el-table-column>
            <el-table-column prop="remark" label="备注"  ></el-table-column>
            <el-table-column prop="status.text" label="状态"  ></el-table-column>
            <el-table-column prop="is_delete.text" label="是否删除"  ></el-table-column>
            <el-table-column prop="create_time" label="创建时间"  ></el-table-column>
            <el-table-column prop="update_time" label="修改时间"  ></el-table-column>
          
            
            
            <el-table-column fixed="right" label="操作">
              <template slot-scope="scope">
                <!-- <el-button @click="detail(scope.row)" type="text" size="small" >详情</el-button>           -->
                <el-button @click="edit(scope.row.password_id)" v-auth="'/plus/password/edit'" type="text" size="small" >修改</el-button> 
                <el-button @click="del(scope.row.password_id)" v-auth="'/plus/password/del'" type="text" size="small" >删除</el-button>         
              </template>
              
            </el-table-column>
          </el-table>
        </div>
  
        <!--分页-->
        <div class="pagination">
          <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" background :current-page="curPage"
            :page-sizes="[20, 50, 100, 200, 300, 500]"
            :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper"
            :total="totalDataNumber">
          </el-pagination>
        </div>
      </div>
     
      <Add v-if="show_add" :dataModel="dataModel" @closeDialog="closeDialogFunc($event, 'add')"></Add>
      <Edit v-if="show_edit" :password_id="password_id" :dataModel="dataModel" @closeDialog="closeDialogFunc($event, 'edit')"></Edit>
    </div>
  </template>
  
  <script>
    import PasswordApi from '@/api/password.js';

    import Add from './dialog/Add.vue';
    import Edit from './dialog/Edit.vue';
    export default {
      components: {
      Add,
      Edit
    },
      data() {
        return {
          /*是否加载完成*/
          loading: true,
          /*列表数据*/
          tableData: [],
          /*一页多少条*/
          pageSize: 20,
          /*一共多少条数据*/
          totalDataNumber: 0,
          /*当前是第几页*/
          curPage: 1,
          /*横向表单数据模型*/
          formInline: {
            search: '',
            account: '',
            status:0,//0 正常 1 冻结
            code:"",
          },
          dataModel:[],
          show_add:false,
          show_edit:false,
          codes:[],//类型
          password_id:"",//修改的ID
        };
      },
      created() {
        //获取类型
        var self = this;
        PasswordApi.getCode({}).then(data => {
            self.codes = data.data;
          }).catch(error => {
        });
        /*获取列表*/
        this.getTableList();
  
      },
      methods: {
        add(){
          this.show_add = true;
        },
        edit(e){
          this.password_id = e
          this.show_edit = true;
        },
        /*跳转订单详情*/
        gotoPage(row) {
          let self = this;
          this.$router.push({
            path: '/order/order/detail',
            query: {
              order_id: row.order_id
            }
          });
        },
  
        /*选择第几页*/
        handleCurrentChange(val) {
          let self = this;
          self.curPage = val;
          self.loading = true;
          self.getTableList();
        },
  
        /*每页多少条*/
        handleSizeChange(val) {
          this.curPage = 1;
          this.pageSize = val;
          this.getTableList();
        },
  
        /*获取列表*/
        getTableList() {
          let self = this;
          let Params = self.formInline;
          Params["listRow"] = JSON.stringify({
            "page": self.curPage,
            "list_rows":self.pageSize,
            })
          PasswordApi.getData(Params).then(data => {
            self.loading = false;
            self.tableData = data.data.list.data;
            self.totalDataNumber = data.data.list.total;
          }).catch(error => {
            self.loading = false;
          });
        },
        del(password_id){
            this.$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            self.loading = true;
            PasswordApi.del({
              password_id:password_id
            }).then(data => {
              self.loading = false;
              this.getTableList();
          }).catch(error => {
              self.loading = false;
            

          });
            
          }).catch(() => {
            this.$message({
              type: 'info',
              message: '已取消删除'
            });
          });
        },
  
        /*搜索查询*/
        onSubmit() {
          let self = this;
          self.loading = true;
          self.curPage = 1;
          let Params = self.formInline;
          self.getTableList();
        },
  
  
        /*关闭弹窗*/
        closeDialogFunc(e, f) {
          if (f == 'add') {
            this.show_add = e.openDialog;
            if (e.type == 'success') {
              this.getTableList();
            }
          }
          if (f == 'edit') {
            this.show_edit = e.openDialog;
            if (e.type == 'success') {
              this.getTableList();
            }
          }
        },
  
      }
    };
  </script>
  <style></style>
  


// WEBPACK FOOTER //
// src/views/plus/password/index.vue